/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */

export type MergeDuplicatesKey = typeof MergeDuplicatesKey[keyof typeof MergeDuplicatesKey];


export const MergeDuplicatesKey = {
  fajta: 'fajta',
  torzs_nev: 'torzs_nev',
  rov: 'rov',
  torzs_szam: 'torzs_szam',
  pedigre: 'pedigre',
} as const;
